/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './muteActorList.defs'
export { main as default } from './muteActorList.defs'
